export default function consoleLogDev(message, ...optionalParams) {
    if (process.env.REACT_APP_ENABLE_DEV_LOG === 'true') {
        console.log(message, ...optionalParams);
    }
}